import * as angular from "angular";
import {IController} from "angular";


export class TriMenuCtrl implements IController {

  mdTheme: IController;
  public menu: any;

  constructor(private $mdTheming, private triTheming, private $element, private triMenu) {
  }

  $onInit() {
    this.menu = this.triMenu.menu;
  }

  $postLink() {
    this.$mdTheming(this.$element);

    const menuColor = this.triTheming.getThemeHue(this.mdTheme, 'primary', 'default');
    const menuColorRGBA = this.triTheming.rgba(menuColor.value);
    this.$element.css({'background-color': menuColorRGBA});
    this.$element.children('md-content').css({'background-color': menuColorRGBA});
  }

}

angular
  .module('triangular.components')
  .component('triMenu', {
    bindings: {
      mdTheme: '<'
    },
    template: require('./menu.html').default,
    controller: TriMenuCtrl
  });
